<script lang="ts">
  import type { TocEntry } from "../markdown";

  export let entries: TocEntry[] = [];
</script>

{#if entries.length > 0}
  <nav class="panel p-4 sticky top-20">
    <div class="text-[10px] uppercase tracking-wider text-text-dim mb-2">On this page</div>
    <ul class="flex flex-col gap-1.5 text-sm">
      {#each entries as entry}
        <li class:pl-3={entry.level === 3}>
          <a
            href={`#${entry.id}`}
            class="text-text-muted hover:text-text transition-colors block truncate"
          >
            {entry.text}
          </a>
        </li>
      {/each}
    </ul>
  </nav>
{/if}
